/**
 * Leitura da biblioteca de modelos da administracao.
 *
 * Rota futura: `GET /api/admin/templates?companyId&from&to`
 * (docs/PLANO-PAINEL-COMPLETO.md, "Admin - Modelos"; tabela `message_templates`),
 * so para `platform_admin`. `companyId` e um FILTRO da administracao (devolve
 * os globais mais os daquela empresa), nao o tenant: a sessao continua
 * decidindo quem chega aqui. `from`/`to` so afetam `sentCount`. Em modo real,
 * ate a rota nascer, a chamada cai em `ErrorPanel` (404) -- nunca em modelo
 * inventado.
 */

import { fetchOrSimulate, rangeQuery, type Envelope } from '../../lib/api';
import { simularModelos } from './mock';
import type { TemplateQuery, TemplatesResponse } from './types';

export function fetchTemplates(filters: TemplateQuery, signal: AbortSignal): Promise<Envelope<TemplatesResponse>> {
  return fetchOrSimulate(
    '/api/admin/templates',
    { ...rangeQuery(filters.range), companyId: filters.companyId },
    signal,
    () => simularModelos(filters),
  );
}
